import { Grid } from '@mairistem/composants';
import {
	type Adresse,
	TiersAdresseList,
	TiersContact,
} from '@mairistem/comptabilite';
import React from 'react';

interface Contact {
	identifiant?: number | string;
	nom?: string;
	prenom?: string;
	telephone?: string;
	fonction?: string;
	courriel?: string;
	identifiantTiers?: number;
	commentaire?: string;
	principal?: boolean;
	urlPhoto?: string;
}

interface TiersFichePanelAdressesContactsProps {
	onChange: (e: unknown) => void;
	contacts?: Contact[];
	adresses?: Adresse[];
	deletedAdresses?: number[];
	deletedContacts?: number[];
	identifiant?: number | string;
}

const TiersFichePanelAdressesContacts = ({
	onChange,
	contacts,
	adresses,
	deletedAdresses,
	deletedContacts,
	identifiant,
}: TiersFichePanelAdressesContactsProps) => (
	<Grid>
		<Grid.Row columns={2}>
			<Grid.Column>
				<TiersAdresseList
					identifiant={identifiant}
					adresses={adresses}
					onChange={onChange}
					deletedAdresses={deletedAdresses}
				/>
			</Grid.Column>
			<Grid.Column>
				<TiersContact
					onChange={onChange}
					contacts={contacts}
					deletedContacts={deletedContacts}
					identifiant={identifiant}
				/>
			</Grid.Column>
		</Grid.Row>
	</Grid>
);

export default TiersFichePanelAdressesContacts;
